// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".padding-bottom3[data-v-431c680c] {\n  padding-bottom: 3px;\n}\n.padding-bottom3-left40[data-v-431c680c] {\n  margin-left: 40px;\n  padding-bottom: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
